export const POST_VENDORRFP_Data = "/api/InfinityX/VendorRFPDetails";
export const SAVE_VENDORRFP_Data = "/api/InfinityX/SaveRFPDetails";

export const GET_ERP_NEWVOUCHERNUM = "/api/InfinityX/NewInwardOrder";

//REPORT
export const GET_ERP_LEDGER_REPORT = "/api/InfinityX/Reports/LedgerAccount";

// export const VENDOR_POST_REGISTER = "/api/licensing/registersubscriber";


export const VENDOR_POST_REGISTER = "/api/licensing/registersubscriber";
// export const VENDOR_POST_LOGIN = "/api/authentication/authenticate";

export const VENDOR_POST_LOGIN = "/api/authentication/authenticate";
export const OTP_VERIFICATION = "/Api/licensing/sendOTP";
export const OTP_VERIFIED = "/Api/licensing/verifyOTP";
export const VENDOR_POST_FORGOT_PASSWORD = "";
export const ADDRESS_DETAILS = "/Api/licensing/updatesubscriber";
export const GET_CREDENTIAL= "api/licensing/GetSubscriber";
export const GET_MAX_TICKET_NUMBER = "/api/support/MaxTicketNumber?TicketType=Support"

// exe and setup download

export const EXEDOWNLOAOD = "/api/downloads/ie5.exe";


//vendor
// export const GET_VENDOR_DASHBOARD = "https://api.jsonbin.io/v3/b/67ab296aad19ca34f8ff5d07";
export const GET_VENDOR_DASHBOARD = "API/RFQ/VendorRFQ";
export const GET_QUOTATION_DETAILS = "API/RFQ/VendorRFQ/";

//support
export const GET_ERP_SUPPORT_DASHBOARD = "/API/Support/Ticket?EntryType=Support"
// export const GET_ERP_SUPPORT_DASHBOARD ="https://api.jsonbin.io/v3/b/66ffc847e41b4d34e43cd031"

//training
export const GET_ERP_TRAINING_DASHBOARD = "/API/Support/Ticket?EntryType=Training"
//user
export const USER_REGISTER = "/api/support/RegisterSubscriberSubUser";

export const QUERY_TICKET = "";
export const POST_RAISE_TICKET = "/API/Support/Ticket";

export const GET_LIST_OF_MODULES = "/API/Support/ModuleList";
export const GET_LIST_OF_CLIENTS = "/API/Support/ClientList";
export const GET_LIST_OF_CLIENTUSER = "/API/Support/ClientUserList/";

// order History

export const GET_PRODUCT_ORDER_HISTORY = "/api/Support/ProductOrderHistory";

export const GET_LICENSE_HISTORY = "/api/Support/LicenseActivationHistory";

// ticketDetails
export const GET_TICKET_DETAILS = "/API/Support/Ticket/";

//quotation

export const POST_RAISE_QUOTATION= "";


export const GET_LIST_OF_USER = "/API/Support/RegisterSubscriberSubUser";

// post Rating in ticket details
export const POST_RATING = "/API/Support/Rating";


export const GET_ERP_TRAINING_TASK = "/api/support/TrainingTask";


export const GET_ALLOTED_TRAINING = "/API/Support/AllotTraining";

export const POST_ALLOT_TRAINING = "/API/Support/AllotTraining";

export const GET_LIST_OF_SUPPORTUSERS = "/api/Support/RegisterSubscriberSubUser";

export const GET_LIST_OF_SUPPORTSTATUS = "/api/Support/StatusList";

export const POST_DAILY_STATUS = "/api/Support/DailyStatus/";
export const GET_DAILYSTATUS_DETAILS = "API/Support/DailyStatus/";
export const GET_ATTACHMENT_DETAILS = "API/Support/TicketMedia/";
export const POST_APPROVAL_PENDING = "api/support/Approval/"
export const POST_VENDOR_CHANGE_PASSWORD = "api/licensing/changepassword/";
export const GET_VENDOR_PROFILE_PICTURE="api/"
export const GET_UNIT_DATA="/api/RFQ/unit"
// export const POST_VENDORRFP_Data = "/api/InfinityX/VendorRFPDetails";
// export const SAVE_VENDORRFP_Data = "/api/InfinityX/SaveRFPDetails";

// export const GET_ERP_NEWVOUCHERNUM = "/api/InfinityX/NewInwardOrder";

// //REPORT
// export const GET_ERP_LEDGER_REPORT = "/api/InfinityX/Reports/LedgerAccount";

// // export const VENDOR_POST_REGISTER = "https://api5.codeplayers.in/api/licensing/registersubscriber";


// export const VENDOR_POST_REGISTER = "http://45.124.144.253:5005/api/licensing/registersubscriber";
// // export const VENDOR_POST_LOGIN = "https://api5.codeplayers.in/api/authentication/authenticate";

// export const VENDOR_POST_LOGIN = "http://45.124.144.253:5005/api/authentication/authenticate";
// export const OTP_VERIFICATION = "http://45.124.144.253:5005/Api/licensing/sendOTP";
// export const OTP_VERIFIED = "http://45.124.144.253:5005/Api/licensing/verifyOTP";
// export const VENDOR_POST_FORGOT_PASSWORD = "";
// export const ADDRESS_DETAILS = "http://45.124.144.253:5005/Api/licensing/updatesubscriber";

// export const GET_MAX_TICKET_NUMBER = "http://45.124.144.253:5005/api/support/MaxTicketNumber?TicketType=Support"

// //vendor
// export const GET_VENDOR_DASHBOARD = "/api/InfinityX/DashboardData";

// //support
// export const GET_ERP_SUPPORT_DASHBOARD = "http://45.124.144.253:5005/API/Support/Ticket?EntryType=Support"
// // export const GET_ERP_SUPPORT_DASHBOARD ="https://api.jsonbin.io/v3/b/66ffc847e41b4d34e43cd031"

// //training
// export const GET_ERP_TRAINING_DASHBOARD = "http://45.124.144.253:5005/API/Support/Ticket?EntryType=Training"
// //user
// export const USER_REGISTER = "http://45.124.144.253:5005/api/support/RegisterSubscriberSubUser";

// export const QUERY_TICKET = "";
// export const POST_RAISE_TICKET = "http://45.124.144.253:5005/API/Support/Ticket";

// export const GET_LIST_OF_MODULES = "http://45.124.144.253:5005/API/Support/ModuleList";
// export const GET_LIST_OF_CLIENTS = "http://45.124.144.253:5005/API/Support/ClientList";
// export const GET_LIST_OF_CLIENTUSER = "http://45.124.144.253:5005/API/Support/ClientUserList/";

// // order History

// export const GET_PRODUCT_ORDER_HISTORY = "http://45.124.144.253:5005/api/Support/ProductOrderHistory";

// export const GET_LICENSE_HISTORY = "http://45.124.144.253:5005/api/Support/LicenseActivationHistory";

// // ticketDetails
// export const GET_TICKET_DETAILS = "http://45.124.144.253:5005/API/Support/Ticket/";

// export const GET_LIST_OF_USER = "http://45.124.144.253:5005/API/Support/RegisterSubscriberSubUser";

// // post Rating in ticket details
// export const POST_RATING = "http://45.124.144.253:5005/API/Support/Rating";


// export const GET_ERP_TRAINING_TASK = "http://45.124.144.253:5005/api/support/TrainingTask";


// export const GET_ALLOTED_TRAINING = "http://45.124.144.253:5005/API/Support/AllotTraining";

// export const POST_ALLOT_TRAINING = "http://45.124.144.253:5005/API/Support/AllotTraining";

// export const GET_LIST_OF_SUPPORTUSERS = "http://45.124.144.253:5005/api/Support/SupportUserList";

// export const GET_LIST_OF_SUPPORTSTATUS = "http://45.124.144.253:5005/api/Support/StatusList";

// export const POST_DAILY_STATUS = "http://45.124.144.253:5005/api/Support/DailyStatus";
// export const GET_DAILYSTATUS_DETAILS = "http://45.124.144.253:5005/API/Support/DailyStatus/";
